import React, { HTMLAttributes } from "react";
import classNames from "classnames";
import { Button } from "./Button";
import {
    JUSTIFY_CONTENT,
    DIRECTION,
    GAP,
    PADDING,
    WIDTH,
    ALIGN_ITEMS,
    PADDING_X,
    PADDING_Y,
} from "../features/foundation";

type LayoutProps = HTMLAttributes<HTMLDivElement> & {
    hidden?: boolean;
    gap?: keyof typeof GAP;
    size?: keyof typeof WIDTH;
    direction?: keyof typeof DIRECTION;
    align?: keyof typeof JUSTIFY_CONTENT;
    valign?: keyof typeof ALIGN_ITEMS;
    height?: string | number;
    padding?: keyof typeof PADDING;
    paddingX?: keyof typeof PADDING_X;
    paddingY?: keyof typeof PADDING_Y;
    as?: "link";
};

/**
 * # Layout
 *
 * * LayoutLeft
 * * LayoutRight
 *
 * @param props LayoutProps
 * @returns
 */
export const Layout = (props: LayoutProps) => {
    const {
        children,
        className,
        style = {},
        direction = "row",
        align = "start",
        gap = 1,
        size = "full", // width
        valign,
        height,
        hidden,
        padding = 0,
        paddingX = 0,
        paddingY = 0,
        ...rest
    } = props;

    return (
        <div
            {...rest}
            hidden={hidden}
            className={classNames(
                GAP[gap],
                PADDING[padding],
                PADDING_X[paddingX],
                PADDING_Y[paddingY],
                size && WIDTH[size],
                DIRECTION[direction],
                JUSTIFY_CONTENT[align],
                valign && ALIGN_ITEMS[valign],
                !hidden && "flex",
                className,
            )}
            style={{ ...style, height }}
        >
            {children}
        </div>
    );
};

const LayoutLeft = (props: Omit<LayoutProps, "direction">) => {
    const { children, gap = 1, size, hidden } = props;

    return (
        <div
            hidden={hidden}
            className={classNames(
                "flex-wrap [&_.uf-form-control]:w-auto",
                size && WIDTH[size],
                GAP[gap],
                !hidden && "flex",
            )}
        >
            {children}
        </div>
    );
};

const LayoutRight = (props: Omit<LayoutProps, "direction">) => {
    const { children, gap = 1, size, hidden } = props;

    return (
        <div
            hidden={hidden}
            className={classNames(
                "flex-1 flex-wrap justify-end [&_.uf-form-control]:w-auto",
                size && WIDTH[size],
                GAP[gap],
                !hidden && "flex",
            )}
        >
            {children}
        </div>
    );
};

Layout.Left = LayoutLeft;
Layout.Right = LayoutRight;
Layout.Button = Button;
